import VueApexCharts from 'vue3-apexcharts';

// ApexCharts is browser-only — registered client-side so <apexchart> is globally available.
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(VueApexCharts);
});
